module.exports = __webpack_public_path__ + "img/1bd256a3.png";